import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../models';
import { contextualizeColumnFormControlOptions } from './contextualize-column-form-control-options.helper';

/**
 * This pipe like contextualizeColumns pipe it removes the first parentControl level from column's formControlOptions value
 * so form makers can create/find the right spot in a contextualized form
 */
@Pipe({
  name: 'contextualizeColumnFormControlOptions',
  standalone: false,
})
export class ContextualizeColumnFormControlOptionsPipe implements PipeTransform {
  transform(column: Column): Column {
    return contextualizeColumnFormControlOptions(column);
  }
}
